import { useEffect, useState } from 'react';

export interface Params {
  skip?: number;
  take?: number;
  region?: string | number;
  commission?: string | number;
  specialization?: string | number;
  embed: string;
  claimedQualification?: string | number;
  appType?: string | number;
  status?: string | number;
  createdAtTo?: string;
  createdAtFrom?: string;
  user?: string | number;
}

export const useApi = (url: string, token: string, params: Params = { embed: 'user' }) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const queryString = new URLSearchParams(params as any).toString();
        const response = await fetch(`${url}?${queryString}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setData(result);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, token, JSON.stringify(params)]);

  return { data, loading, error };
};
